import moment from 'moment';

const dateToString = (date) => {
    const formatDate = moment(date);
    if (formatDate.isValid()) {
        return formatDate.format('DD/MM/YYYY');
    }
    return '';
};

export { dateToString };
